var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7913 0.583496C6.97676 0.583496 0.583008 6.97725 0.583008 14.7918C0.583008 22.6064 6.97676 29.0002 14.7913 29.0002C22.6059 29.0002 28.9997 22.6064 28.9997 14.7918C28.9997 6.97725 22.6059 0.583496 14.7913 0.583496ZM20.9009 11.3818L14.3651 19.9068C14.0809 20.191 13.6547 20.4752 13.2284 20.4752C12.8022 20.4752 12.3759 20.3331 12.0918 19.9068L8.68176 15.5022C8.25551 14.9339 8.25551 13.9393 8.96592 13.5131C9.67634 13.0868 10.5288 13.0868 10.9551 13.7972L13.2284 16.781L18.6276 9.67683C19.0538 9.1085 20.0484 8.96641 20.6168 9.39266C21.3272 9.81891 21.3272 10.6714 20.9009 11.3818Z",
    fill: "#07B262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/Step1.d08568a01c51de7e3391ef9aab9613c9.svg";
export { ForwardRef as ReactComponent };